import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.9edd30f7-65aa-4ffd-a7c0-d18f49f47ab8/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins_home/workspace/tingle.9edd30f7-65aa-4ffd-a7c0-d18f49f47ab8/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.9edd30f7-65aa-4ffd-a7c0-d18f49f47ab8/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import { Template } from '../../features/Template';
import { NotFound } from '../../features/Layout';
import { getHomePageData } from '../../features/Help/getHelpData';
import { jsx as _jsx } from "react/jsx-runtime";
export var HelpHomePage = function HelpHomePage(_ref) {
  var template = _ref.template,
      preview = _ref.preview;

  if (!template) {
    return /*#__PURE__*/_jsx(NotFound, {});
  }

  return /*#__PURE__*/_jsx(Template, _objectSpread(_objectSpread({}, template), {}, {
    preview: preview
  }));
};

HelpHomePage.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var smartlingLanguage, _ref2$preview, preview;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            smartlingLanguage = _ref2.smartlingLanguage, _ref2$preview = _ref2.preview, preview = _ref2$preview === void 0 ? false : _ref2$preview;
            _context.next = 3;
            return getHomePageData(preview, smartlingLanguage);

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

export default HelpHomePage;